<template>
  <div class="w-full">
    <swiper :options="planswiperOption" class="">
      <swiper-slide
        class="cursor-pointer rounded-12px"
        v-for="item in related_items"
        :key="item.objectId"
      >
        <div class="bg-white rounded-12px">
          <div class="flex w-full items-center absolute top-0 left-0 px-5 py-4">
            <div class="w-10/12">
              <div class="flex justify-between items-center">
                <div class="">
                  <h2
                    class="text-white fsize14 flex items-center font-semibold"
                  >
                    {{ item.heads }}
                    <feather-icon
                      icon="InfoIcon"
                      class="ml-1 text-white"
                      svgClasses="w-5 h-5"
                    />
                  </h2>
                </div>
              </div>
            </div>
            <div class="w-2/12 flex justify-end">
              <div
                class="flex justify-center bg-white rounded-full items-center w-10 h-10"
              >
                <feather-icon
                  icon="ChevronRightIcon"
                  svgClasses="w-5 h-5"
                  class="text-secondary font-semibold flex"
                />
              </div>
            </div>
          </div>

          <img
            :src="item.image"
            class="object-cover bg-fas w-full h-185px border-round"
            alt="banh"
          />
          <div
            class="w-full mt-3 items-center absolute px-5 py-6 bottom-0 left-0"
          >
            <p class="text-white">VR Showrooms</p>
            <h2 class="text-white text-xl font-semibold items-center">
              Explore Web3 <br />
              with BR<span class="text-brcolor">AI</span>NED Elysium
            </h2>
          </div>
        </div>
      </swiper-slide>
      <div
        class="swiper-pagination cust-posi"
        slot="pagination"
        id="paginationdots2"
      ></div>
    </swiper>
  </div>
</template>
<script>
import { mapState } from "vuex";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      planswiperOption: {
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        spaceBetween: 25,
        pagination: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: "#paginationdots2",
        },
      },

      related_items: [
        {
          name: "Template 1",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/news.png",
          heads: "What's New",
          title: "VR Showrooms",
        },
        {
          name: "Template 2",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/news.png",
          heads: "What's New",
        },
        {
          name: "Template 3",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/news.png",
          heads: "What's New",
        },
      ],
      products: [],
    };
  },

  computed: {
    ...mapState("admin", ["selectedPlan"]),
  },
};
</script>
<style lang="scss">
.swiper-pagination {
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: white;
  }
}

.border-user {
  border: 4px solid #0193a1;
  border-radius: 100%;
}
// .cust-bullet > .swiper-pagination-bullet {
// }
.cust-bullet > .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
  margin-left: 3px !important;
  margin-right: 3px !important;
}
</style>
